export default {
  FLAVOR: FLAVOR,
  DEBUG: DEBUG,
  VERSION_CODE: VERSION_CODE,
  BUILD_TYPE: BUILD_TYPE,
  APPLICATION_ID: APPLICATION_ID,
  VERSION_NAME: VERSION_NAME,
  CHAIN: CHAIN,
};